// Company self sign-up (mirrors the server's SIGNUP_* constants).
export const SIGNUP_PATH = '/auth/signup';

// Mirrors the server's sign-up schema: the company name is 2–120 characters.
export const COMPANY_NAME_MIN_LENGTH = 2;

export const COMPANY_NAME_MAX_LENGTH = 120;

export const SIGNUP_OTP_LENGTH = 6;

export const SIGNUP_OTP_RESEND_COOLDOWN_SECONDS = 60;

// Free mailbox domains the server refuses; checked early for a friendlier message.
export const FREE_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  'gmail.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.com.tr',
  'outlook.com',
  'outlook.com.tr',
  'live.com',
  'msn.com',
  'yahoo.com',
  'yahoo.com.tr',
  'ymail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'gmx.com',
  'gmx.de',
  'web.de',
  'mail.com',
  'mail.ru',
  'yandex.com',
  'yandex.com.tr',
  'yandex.ru',
  'proton.me',
  'protonmail.com',
  'zoho.com',
  'hushmail.com',
  'tutanota.com',
]);

// Server answer to a sign-up whose e-mail already has an account; the form offers to sign in.
export const SIGNUP_EMAIL_IN_USE_ERROR = 'MESSAGES.SIGNUP.EMAIL_IN_USE';
